import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/browser';
import { search } from 'src/app/models/route/route-paths';
import { AuthService } from '../../../../lib/auth.service';
import { clearUserProfile } from '../../../shared/user-profile/user-profile.actions';
import { Dispatcher } from '../../dispatcher';

@Injectable({ providedIn: 'root' })
export class GlobalHeaderCommands {
  constructor(
    private readonly auth: AuthService,
    private readonly dispatcher: Dispatcher,
    private readonly router: Router,
  ) {}

  async signOut() {
    try {
      await this.auth.signOut();
      this.dispatcher.dispatch(clearUserProfile());
      this.router.navigateByUrl(search);
    } catch (e) {
      Sentry.captureException(e);
      // TODO @修復不可能なエラーが発生した場合の、ユーザーへの見せ方を決める #16
      //  https://github.com/toreta/skipr-sp/issues/16
    }
  }
}
